import image from '../../../../static/life-primary@large.jpg';

const key = 'life-at-kingston';

export default {
  rootNavKey: [key],
  parentKeys: [key],
  image,
};
